import { on, off } from "@utils/listener";
import anime from "animejs";
class HumbleBundleLinks {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;
    this._onClick = this._onClick.bind(this);
    this._onLoad = this._onLoad.bind(this);
  }

  init() {
    this._bindEvents();
  }
  destroy() {
    this._unbindEvents();
    this.el = null;
    this.emitter = null;
    this.iframe = null;
    this._onClick = null;
    this._onLoad = null;
  }

  _bindEvents() {
    on(this.el, "click", this._onClick);
  }
  _unbindEvents() {
    off(this.el, "click", this._onClick);
    if(this.iframe) off(this.iframe, "load", this._onLoad);
  }

  _onClick(event) {
    if(event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // get the element URL, should be an URL including "humblebundle.com/widget"
    const url = this.el.href;

    // if no url, do nothing, or if it doesn't include "humblebundle.com/widget"
    if(!url || !url.includes("humblebundle.com/widget")) return;

    const iframe = this._createIframe(url);
    this.emitter.emit("SiteDialog.open", iframe);
  }

  _createIframe(url) {
    this.iframe = document.createElement("iframe");
    this.iframe.src = url;
    this.iframe.width = "100%";
    this.iframe.height = "100%";
    this.iframe.frameBorder = 0;
    this.iframe.allowFullscreen = true;

    // set opacity to 0, so it's not visible
    this.iframe.style.opacity = 0;

    // add load event listener
    on(this.iframe, "load", this._onLoad);

    return this.iframe;
  }

  _onLoad() {
    anime({
      targets: this.iframe,
      opacity: 1,
      easing: "linear",
      duration: 300
    });
  }

}

export default HumbleBundleLinks;
